import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import * as echarts from 'echarts';
import DashboardMainContainer from "../common/Containers/DashboardMainContainer";
import {
  AdminMetric,
  AdminPanelTitle,
  AdminMainText,
  AdminMetadataText,
  AdminSupportingText,
  AdminLinkAction,
} from "../../sections/AdminDashboard/shared/adminUx";
import {
  AdminWidgetHeader,
  AdminWidgetPeriodFilter,
  AdminWidgetMetricDelta,
} from "../BusinessDashboard/AdminWidgetChrome";
import { dashboardChartTooltipAxisFormatter } from "../BusinessDashboard/dashboardChartTooltip";

const FollowedBusinessesWidget = () => {
  const navigate = useNavigate();
  const [filterPeriod, setFilterPeriod] = useState("7 Days");
  const [unfollowedIds, setUnfollowedIds] = useState(new Set());
  const [replacementBusinesses, setReplacementBusinesses] = useState([]);
  const [replacementIndex, setReplacementIndex] = useState(0);
  const chartRef = useRef(null);

  // Pool of replacement businesses to show when unfollowing
  const replacementBusinessPool = [
    {
      id: 101,
      name: "Quick Fix Handyman",
      profileImage: "https://tradeposter.blob.core.windows.net/tradeposter/images/Profile-image-1743126772423.jpg",
      category: "Handyman",
      location: "Melbourne VIC 3000"
    },
    {
      id: 102,
      name: "Sparkle Window Cleaning",
      profileImage: "https://tradeposter.blob.core.windows.net/tradeposter/images/Profile-image-1743126772423.jpg",
      category: "Window Cleaning",
      location: "Southbank VIC 3006"
    },
    {
      id: 103,
      name: "Carpet Care Specialists",
      profileImage: "https://tradeposter.blob.core.windows.net/tradeposter/images/Profile-image-1743126772423.jpg",
      category: "Carpet Cleaning",
      location: "Port Melbourne VIC 3207"
    },
    {
      id: 104,
      name: "Fence Masters",
      profileImage: "https://tradeposter.blob.core.windows.net/tradeposter/images/Profile-image-1743126772423.jpg",
      category: "Fencing",
      location: "Footscray VIC 3011"
    },
    {
      id: 105,
      name: "Tile & Grout Experts",
      profileImage: "https://tradeposter.blob.core.windows.net/tradeposter/images/Profile-image-1743126772423.jpg",
      category: "Tiling",
      location: "St Kilda VIC 3182"
    },
    {
      id: 106,
      name: "Gutter Guard Pro",
      profileImage: "https://tradeposter.blob.core.windows.net/tradeposter/images/Profile-image-1743126772423.jpg",
      category: "Gutter Cleaning",
      location: "Essendon VIC 3040"
    },
    {
      id: 107,
      name: "Pest Control Plus",
      profileImage: "https://tradeposter.blob.core.windows.net/tradeposter/images/Profile-image-1743126772423.jpg",
      category: "Pest Control",
      location: "Hawthorn VIC 3122"
    },
    {
      id: 108,
      name: "Solar Solutions",
      profileImage: "https://tradeposter.blob.core.windows.net/tradeposter/images/Profile-image-1743126772423.jpg",
      category: "Solar Installation",
      location: "Sunshine VIC 3020"
    }
  ];

  // Dynamic data for different periods with businesses
  const followedDataByPeriod = {
    '7 Days': {
      labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      data: [1161, 2180, 2800, 5250, 3300, 9320, 12345],
      current: 74,
      change: 8,
      businesses: [
        {
          id: 1,
          name: "Smith Plumbing Services",
          profileImage: "https://tradeposter.blob.core.windows.net/tradeposter/images/Profile-image-1743126772423.jpg",
          category: "Plumbing",
          location: "North Melbourne VIC 3051"
        },
        {
          id: 2,
          name: "Westside Electrical",
          profileImage: "https://tradeposter.blob.core.windows.net/tradeposter/images/Profile-image-1743126772423.jpg",
          category: "Electrical",
          location: "North Melbourne VIC 3051"
        },
        {
          id: 3,
          name: "Bright Roof Repairs",
          profileImage: "https://tradeposter.blob.core.windows.net/tradeposter/images/Profile-image-1743126772423.jpg",
          category: "Roofing",
          location: "South Melbourne VIC 3205"
        }
      ]
    },
    '14 Days': {
      labels: ['Week 1', 'Week 2'],
      data: [6000, 12345],
      current: 68,
      change: 12,
      businesses: [
        {
          id: 1,
          name: "Smith Plumbing Services",
          profileImage: "https://tradeposter.blob.core.windows.net/tradeposter/images/Profile-image-1743126772423.jpg",
          category: "Plumbing",
          location: "North Melbourne VIC 3051"
        },
        {
          id: 4,
          name: "Pro Painters Melbourne",
          profileImage: "https://tradeposter.blob.core.windows.net/tradeposter/images/Profile-image-1743126772423.jpg",
          category: "Painting",
          location: "Carlton VIC 3053"
        },
        {
          id: 5,
          name: "Green Thumb Landscaping",
          profileImage: "https://tradeposter.blob.core.windows.net/tradeposter/images/Profile-image-1743126772423.jpg",
          category: "Landscaping",
          location: "Fitzroy VIC 3065"
        }
      ]
    },
    '30 Days': {
      labels: ['Week 1', 'Week 2', 'Week 3', 'Week 4'],
      data: [8000, 9500, 11000, 12345],
      current: 56,
      change: 18,
      businesses: [
        {
          id: 6,
          name: "Elite HVAC Solutions",
          profileImage: "https://tradeposter.blob.core.windows.net/tradeposter/images/Profile-image-1743126772423.jpg",
          category: "HVAC",
          location: "Richmond VIC 3121"
        },
        {
          id: 7,
          name: "Clean Masters Pro",
          profileImage: "https://tradeposter.blob.core.windows.net/tradeposter/images/Profile-image-1743126772423.jpg",
          category: "Cleaning",
          location: "Collingwood VIC 3066"
        },
        {
          id: 8,
          name: "Locksmith 24/7",
          profileImage: "https://tradeposter.blob.core.windows.net/tradeposter/images/Profile-image-1743126772423.jpg",
          category: "Locksmith",
          location: "Brunswick VIC 3056"
        }
      ]
    },
    '90 Days': {
      labels: ['Month 1', 'Month 2', 'Month 3'],
      data: [6000, 9000, 12345],
      current: 38,
      change: 28,
      businesses: [
        {
          id: 9,
          name: "Apex Roofing Experts",
          profileImage: "https://tradeposter.blob.core.windows.net/tradeposter/images/Profile-image-1743126772423.jpg",
          category: "Roofing",
          location: "Docklands VIC 3008"
        },
        {
          id: 10,
          name: "Premium Flooring Co",
          profileImage: "https://tradeposter.blob.core.windows.net/tradeposter/images/Profile-image-1743126772423.jpg",
          category: "Flooring",
          location: "South Yarra VIC 3141"
        },
        {
          id: 11,
          name: "BuildRight Renovations",
          profileImage: "https://tradeposter.blob.core.windows.net/tradeposter/images/Profile-image-1743126772423.jpg",
          category: "Renovation",
          location: "Prahran VIC 3181"
        }
      ]
    }
  };

  // Get current period data
  const followedData = followedDataByPeriod[filterPeriod];
  
  // Combine original businesses (excluding unfollowed) with replacement businesses (also excluding unfollowed)
  const originalBusinesses = followedData.businesses.filter(
    business => !unfollowedIds.has(business.id)
  );
  const filteredReplacements = replacementBusinesses.filter(
    business => !unfollowedIds.has(business.id)
  );
  const followedBusinesses = [...originalBusinesses, ...filteredReplacements];

  // Initialize chart
  useEffect(() => {
    if (chartRef.current) {
      const chart = echarts.init(chartRef.current);
      const option = {
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(255, 255, 255, 0.95)",
          borderColor: "#e5e7eb",
          borderWidth: 1,
          textStyle: { color: "#374151" },
          renderMode: "html",
          formatter: (params) => dashboardChartTooltipAxisFormatter(params, "Following"),
        },
        grid: { 
          top: 0, 
          right: 0, 
          bottom: 0, 
          left: 0,
          containLabel: false
        },
        xAxis: {
          type: 'category',
          data: followedData.labels,
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: { show: false },
          boundaryGap: false
        },
        yAxis: {
          type: 'value',
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: { show: false },
          splitLine: { show: false },
          boundaryGap: false
        },
        series: [{
          name: 'Following',
          data: followedData.data,
          type: 'line',
          lineStyle: { 
            color: '#2E00FF', 
            width: 2 
          },
          areaStyle: { 
            color: { 
              type: 'linear', 
              x: 0, y: 0, x2: 0, y2: 1, 
              colorStops: [
                { offset: 0, color: 'rgba(123, 98, 217, 0.4)' }, 
              ] 
            } 
          },
          symbol: 'none',
          symbolSize: 0
        }]
      };
      chart.setOption(option);
      
      // Handle resize
      const handleResize = () => {
        chart.resize();
      };
      window.addEventListener('resize', handleResize);
      
      // Cleanup
      return () => {
        window.removeEventListener('resize', handleResize);
        chart.dispose();
      };
    }
  }, [filterPeriod, followedData]);

  const handleViewAll = () => {
    navigate("/customer-dashboard/followed-businesses");
  };

  const handleViewProfile = (businessId) => {
    navigate(`/poster-profile/${businessId}`);
  };

  const handleMessage = (businessId) => {
    navigate(`/customer-dashboard/inbox/chats`);
  };

  const handleUnfollow = (businessId) => {
    // Add business ID to unfollowed set to remove it from display
    setUnfollowedIds(prev => new Set([...prev, businessId]));
    
    // Add a replacement business from the pool if available
    if (replacementIndex < replacementBusinessPool.length) {
      const newBusiness = replacementBusinessPool[replacementIndex];
      setReplacementBusinesses(prev => [...prev, newBusiness]);
      setReplacementIndex(prev => prev + 1);
    }
  };

  return (
    <DashboardMainContainer className="masonry-item w-[350px] h-[550px] flex flex-col overflow-hidden">
      <AdminWidgetHeader title="Following">
        <AdminWidgetPeriodFilter period={filterPeriod} onPeriodChange={setFilterPeriod} />
      </AdminWidgetHeader>

      <div className="p-4 space-y-4">
        <div className="flex items-start justify-between gap-4">
          <div className="flex-1">
            <AdminMetric size="large" className="text-offblack mb-1 block tabular-nums">
              {followedData.current}
            </AdminMetric>
            <div className="flex items-center gap-1">
              <AdminPanelTitle className="text-offblack mr-2">Followed Businesses</AdminPanelTitle>
              <AdminWidgetMetricDelta value={followedData.change} trend="up" />
            </div>
          </div>
          
          {/* Right side - Chart */}
          <div className="w-36 h-16 flex-shrink-0">
            <div ref={chartRef} className="w-full h-full"></div>
          </div>
        </div>

        {/* Business Updates List */}
        <div className="space-y-0 border-t border-lightgray pt-3">
          {followedBusinesses.length > 0 ? (
            followedBusinesses.map((business, index) => (
              <div key={business.id}>
                <div className="p-2">
                  {/* Business Header with Profile Image */}
                  <div className="flex items-start gap-3 mb-2">
                    <img
                      className="object-cover rounded-full w-10 h-10 cursor-pointer flex-shrink-0"
                      src={business.profileImage}
                      alt={business.name}
                      onClick={() => handleViewProfile(business.id)}
                    />
                    <div className="flex-1 min-w-0">
                      <div className="mb-1">
                        <AdminMainText className="text-offblack truncate block">
                          {business.name}
                        </AdminMainText>
                      </div>
                      <AdminSupportingText className="text-mediumgray mb-1 block">
                        {business.category}
                      </AdminSupportingText>
                      <AdminMetadataText className="text-mediumgray truncate mb-2 block">
                        {business.location}
                      </AdminMetadataText>
                      <div className="flex items-center gap-2">
                        <AdminLinkAction
                          type="button"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleViewProfile(business.id);
                          }}
                        >
                          View profile
                        </AdminLinkAction>
                        <span className="text-lightgray">|</span>
                        <AdminLinkAction
                          type="button"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleMessage(business.id);
                          }}
                        >
                          Message
                        </AdminLinkAction>
                        <span className="text-lightgray">|</span>
                        <AdminLinkAction
                          type="button"
                          className="!text-alertred hover:!text-alertred"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleUnfollow(business.id);
                          }}
                        >
                          Unfollow
                        </AdminLinkAction>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center py-6">
              <AdminSupportingText className="text-offblack mb-2 block">
                You&apos;re not following any businesses yet.
              </AdminSupportingText>
              <AdminMetadataText className="text-mediumgray block">
                Follow your favourite trades to see their updates here.
              </AdminMetadataText>
            </div>
          )}
        </div>

      </div>
    </DashboardMainContainer>
  );
};

export default FollowedBusinessesWidget;
